import { useState, useEffect } from "react";

interface CalendarCurrentTimeLineProps {
  startHour: number;
  slotHeight: number; // px per slot (30min)
}

export const CalendarCurrentTimeLine = ({
  startHour,
  slotHeight,
}: CalendarCurrentTimeLineProps) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(interval);
  }, []);

  const hours = now.getHours();
  const minutes = now.getMinutes();
  const totalMinutes = (hours - startHour) * 60 + minutes;
  const slotMinutes = 30;
  const top = (totalMinutes / slotMinutes) * slotHeight;

  if (top < 0) return null;

  return (
    <div
      className="absolute left-0 right-0 z-30 pointer-events-none"
      style={{ top: `${top}px` }}
    >
      <div className="relative flex items-center">
        {/* Circle indicator */}
        <div className="absolute -left-[5px] w-[10px] h-[10px] rounded-full bg-destructive" />
        {/* Line */}
        <div className="w-full h-[2px] bg-destructive" />
      </div>
    </div>
  );
};
